// source: type/purchasable_price.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.PurchasablePrice', null, global);
goog.exportSymbol('proto.type.PurchasablePrice.TaxType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PurchasablePrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.PurchasablePrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PurchasablePrice.displayName = 'proto.type.PurchasablePrice';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PurchasablePrice.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PurchasablePrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PurchasablePrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PurchasablePrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    taxType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    minimumPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of PurchasablePrice as accepted by the `fromObject` method.
 * @record
 */
proto.type.PurchasablePrice.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.taxType;

  /** @type {?|undefined} */
  this.minimumPrice;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PurchasablePrice.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PurchasablePrice}
 */
proto.type.PurchasablePrice.fromObject = function(obj) {
  var msg = new proto.type.PurchasablePrice();
  obj.taxType != null && jspb.Message.setField(msg, 1, obj.taxType);
  obj.minimumPrice != null && jspb.Message.setField(msg, 2, obj.minimumPrice);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PurchasablePrice}
 */
proto.type.PurchasablePrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PurchasablePrice;
  return proto.type.PurchasablePrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PurchasablePrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PurchasablePrice}
 */
proto.type.PurchasablePrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.type.PurchasablePrice.TaxType} */ (reader.readEnum());
      msg.setTaxType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinimumPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PurchasablePrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PurchasablePrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PurchasablePrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PurchasablePrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaxType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMinimumPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.type.PurchasablePrice.TaxType = {
  INCLUDE_TAX: 0,
  EXCLUDE_TAX: 1
};

/**
 * optional TaxType tax_type = 1;
 * @return {!proto.type.PurchasablePrice.TaxType}
 */
proto.type.PurchasablePrice.prototype.getTaxType = function() {
  return /** @type {!proto.type.PurchasablePrice.TaxType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.type.PurchasablePrice.TaxType} value
 * @return {!proto.type.PurchasablePrice} returns this
 */
proto.type.PurchasablePrice.prototype.setTaxType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional double minimum_price = 2;
 * @return {number}
 */
proto.type.PurchasablePrice.prototype.getMinimumPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.type.PurchasablePrice} returns this
 */
proto.type.PurchasablePrice.prototype.setMinimumPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


goog.object.extend(exports, proto.type);
